var __rspack_ns_object = {"rE":"8.1.1"}